import { FC, useCallback, useContext, useEffect } from 'react'
import { AddPaymentMethodsPaneButton, BACK_BUTTON_PROPS, PayCardConfirmPaneButton, PayCardMethodPaneButton } from 'components/features/pfm/Button/FloatingPaneButtons'
import SelectPaymentMethodFields from 'components/features/creditCard/creditCardPanes/paneFormFields/SelectPaymentMethodFields'
import Flex from 'components/atoms/Flex/Flex'
import { useFormContext } from 'react-hook-form'
import { CreditCardFloatingPane } from 'components/features/creditCard/creditCardStore/floatingPane'
import { PaneContext } from 'components/features/pfm/FloatingPaneHost/FloatingPaneHost'
import { cardPaymentMethodsSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

const PayCardMethodSelectStep: FC<{}> = () => {
  const { watch, setValue } = useFormContext()
  const pane = useContext(PaneContext) as CreditCardFloatingPane
  const isAutoPay = pane?.mode === 'autoPay'
  const fieldValue = watch('payment_method')
  const paymentMethods = useStoreSelector(cardPaymentMethodsSelector)
  const setMethodFieldAsTouched = useCallback(() => {
    setValue('payment_method', fieldValue, { shouldTouch: true })
  }, [fieldValue, setValue])
  useEffect(() => {
    // Select the first paymentMethod after adding it.
    const onlyOnePaymentMethod = paymentMethods?.length === 1
    if (!onlyOnePaymentMethod) {
      return
    }

    const firstMethodUid = paymentMethods && paymentMethods[0]?.uid
    if (fieldValue !== firstMethodUid) {
      setValue('payment_method', firstMethodUid, { shouldTouch: true })
    }
  }, [fieldValue, paymentMethods, setValue])

  return (
    <Flex padding='large-responsive'>
      <section>
        <h2>Select a payment method</h2>
        <p>Which of your accounts would you like to use to pay your credit card bill?</p>
      </section>
      <SelectPaymentMethodFields />
      <PayCardConfirmPaneButton
        text='Set Payment Method'
        qaMarker='submit-button'
        beforeOnClick={ setMethodFieldAsTouched }
      />
      <AddPaymentMethodsPaneButton
        text='Add Another Payment Method'
        style='textOnly'
        size='tiny'
        fullWidth
        qaMarker='submit-button'
        backButton={ <PayCardMethodPaneButton { ...BACK_BUTTON_PROPS } isAutoPay={ isAutoPay } /> }
      />
    </Flex>
  )
}

export default PayCardMethodSelectStep
